import { render, staticRenderFns } from "./barra-lateral-observaciones.vue?vue&type=template&id=c5220d54&scoped=true&"
import script from "./barra-lateral-observaciones.vue?vue&type=script&lang=ts&"
export * from "./barra-lateral-observaciones.vue?vue&type=script&lang=ts&"
import style0 from "./barra-lateral-observaciones.vue?vue&type=style&index=0&id=c5220d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5220d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow,VSkeletonLoader,VSpacer,VTextField})
